module.exports = __webpack_public_path__ + "img/elephant_walk.5af164f7.gif";